// extracted by mini-css-extract-plugin
module.exports = {"nominationsNumber":"FinalResultsLayout_nominationsNumber__2LHe3","nominationsName":"FinalResultsLayout_nominationsName__15ZaO","grid":"FinalResultsLayout_grid__1-2qo"};